import { render, staticRenderFns } from "./HomeFavorites.vue?vue&type=template&id=6945b052"
import script from "./HomeFavorites.vue?vue&type=script&lang=js"
export * from "./HomeFavorites.vue?vue&type=script&lang=js"
import style0 from "./HomeFavorites.vue?vue&type=style&index=0&id=6945b052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports